import {useCallback} from "react";
import {
    downLoadExcel,
    getDataList,
    getExcelSample,
    getHeadersForSetting,
    refreshExcel,
} from "../../api/file/FileService";
import {handleActiveError} from "../sonner/ToastBasic";

/**
 * 엑셀 그리드/다운로드 공통 조회: 헤더 갱신(refresh) 후 데이터 조회(select-data)
 * @returns {Promise<object|null>} 시트별 데이터 map, 실패 시 null
 */
export async function fetchExcelGridData(entityName, searchConditions) {
    const refreshRes = await refreshExcel(entityName);
    if (refreshRes.status === 202) {
        alert(`${refreshRes.data?.title ?? "오류"} 관리자에게 문의하세요`);
        return null;
    }
    if (refreshRes.status !== 200) {
        handleActiveError({message: "엑셀 헤더 갱신에 실패했습니다."});
        return null;
    }

    const response = await getDataList(entityName, searchConditions);
    return response?.data ?? null;
}

/**
 * 엑셀 다운로드: refreshExcel → getDataList → downLoadExcel
 * @param {string} entityName - API 엔티티명 (예: 'Asset', 'History')
 * @param {object} searchConditions - 목록 검색 조건
 */
export async function downloadExcelByEntity(entityName, searchConditions) {
    const excelData = await fetchExcelGridData(entityName, searchConditions);
    if (excelData && Object.keys(excelData).length > 0) {
        await downLoadExcel(excelData);
    } else if (excelData !== null) {
        handleActiveError({message: "조회된 데이터가 없습니다."});
    }
}

/**
 * 목록 검색 조건을 묶어 두고, handleDownloadClick('Asset') 형태로 JsGrid onDownloadClick에 넘길 핸들러를 만든다.
 * @param {object} searchConditions - saveConditions 등 목록 검색 조건
 * @returns {(entityName: string) => () => Promise<void>}
 */
export function useExcelDownloadClick(searchConditions) {
    return useCallback((entityName) => async () => {
        try {
            await downloadExcelByEntity(entityName, searchConditions);
        } catch {
            handleActiveError({message: "엑셀 데이터 조회에 실패했습니다."});
        }
    }, [searchConditions]);
}

/**
 * 엑셀 양식(템플릿) 다운로드: getHeadersForSetting → getExcelSample
 */
export async function downloadExcelTemplateByEntity(entityName) {
    const res = await getHeadersForSetting(entityName);
    console.log(res)
    if (res.status === 202) {
        alert(`${res.data?.title ?? "오류"}\n${res.data?.reason ?? ""}`);
        return;
    }
    if (res.status !== 200) {
        handleActiveError({message: "엑셀 템플릿 헤더 조회에 실패했습니다."});
        return;
    }
    // 설정 API는 시트별 컬럼 + excelOrders(시트 순서)를 함께 내려줌. 샘플 생성 API는 Map<시트명, List<ColumnDto>>만 기대하므로 excelOrders는 제외.
    const {excelOrders: _excelOrders, ...excelHeaderOnly} = res.data ?? {};
    await getExcelSample(entityName, excelHeaderOnly);
}
